import bookingImportWizardTemplate from '../core/wizards/bookingImportWizard.html';
import bookingExportWizardTemplate from '../core/wizards/bookingExportWizard.html';

angular
  .module('cfn')
  .factory('bookingImportWizardService', bookingImportWizardService);

bookingImportWizardService.$inject = ['$dialog', '$q', 'bookingIsoXmlConfig'];

function bookingImportWizardService($dialog, $q, bookingIsoXmlConfig) {
  const openImportDialog = isFendt => {
    const isoXmlWizardRights = bookingIsoXmlConfig.requiredRights;
    if (!app.hasRight(isoXmlWizardRights)) {
      return $q.reject(
        'User has not all required rights to use the IsoXML Wizard'
      );
    }

    return $dialog
      .dialog({
        backdropClick: false,
        dialogClass: 'wizard-modal',
        resolve: {
          isFendt: () => isFendt
        }
      })
      .open(bookingImportWizardTemplate, 'bookingImportWizardController');
  };

  const openExportDialog = () => {
    return $dialog
      .dialog({
        backdropClick: false,
        dialogClass: 'isoexport-wizard-modal'
      })
      .open(bookingExportWizardTemplate, 'bookingExportWizardController');
  };

  return {
    openImportDialog,
    openExportDialog
  };
}
